import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import StarIcon from '@lt/components/icons-react/rebrand/Star';

import type { ISidebarHotel } from 'checkout/types/hotelTypes';

import { formatDateToDayShort } from 'src/utils/dateUtils';
import AboutRoomButton from 'checkout/components/AboutRoom';

import styles from './sidebarHotel.module.css';

export const SidebarHotel: FC<ISidebarHotel> = ({
  location,
  name,
  stars,
  className = '',
  touristsText,
  startDate,
  endDate,
  image,
  meal,
  goToHotel,
}) => {
  const startDateShort = formatDateToDayShort(startDate);
  const endDateShort = formatDateToDayShort(endDate);

  return (
    <div className={cn(className, styles.container)}>
      <button className={styles.header} type="button" onClick={goToHotel}>
        <div className={cn(styles.text, styles.titleText)}>
          <span>{`${name},`}</span>
          &nbsp;
          <div className={styles.stars}>
            <span>{stars}</span>
            <StarIcon className={styles.starIcon} />
          </div>
        </div>
        <img className={styles.hotelIcon} src={image} alt={name} />
      </button>

      <div className={styles.text}>
        {`${startDateShort} – ${endDateShort}, ${touristsText}`}
      </div>

      <div className={styles.text}>{location}</div>

      <div className={styles.text}>
        <AboutRoomButton className={styles.roomText} />
        {' · '}
        <span>{meal}</span>
      </div>
    </div>
  );
};
